import {
  Translation,
} from '@o3r/core';

export interface RecoveryTranslation extends Translation {
  /**
   * Paragraph to contact the support
   */
  contactSupport: string;

  /**
   * Label displayed on the contact support button
   */
  contactSupportButton: string;

  /**
   * Url to contact the support
   */
  contactSupportUrl: string;

  /**
   * Label for the button to come back to retrieve my booking
   */
  retrieveBookingButtonLabel: string;

  /**
   * Default error Message to display when there is no error retrieved from the service.
   */
  defaultError: string;

  /**
   * Url for the button to come back to retrieve my booking
   */
  retrieveBookingButtonUrl: string;

  /**
   * Custom title for refund teaser in recovery page
   */
  customRefundTeaserTitle: string;

  /**
   * Custom body for refund teaser in recovery page
   */
  customRefundTeaserBody: string;

  /**
   * Custom button label for refund teaser in recovery page
   */
  customRefundTeaserButtonLabel: string;

  /**
   * Information message title when the PNR is already cancelled
   */
  pnrAlreadyCancelledInfoTitle: string;

  /**
   * Information message body when the PNR is already cancelled
   */
  pnrAlreadyCancelledInfoMessage: string;

  /**
   * Text displayed in the next travel pannel as title content
   */
  nextTravel: string;

  /**
   * Text displayed in the next travel pannel as message content
   */
  nextFlight: string;

  /**
   * Text displayed in the next travel pannel as url targeted by the button
   */
  nextFlightUrl: string;

  /**
   * Text displayed in the next travel pannel as button content
   */
  searchNextFlight: string;

  /**
   * Title displayed when the rebooking is in progress
   */
  rebookingInProgressTitle: string;

  /**
   * Message displayed when the rebooking is in progress
   */
  rebookingInProgressMessage: string;
}

export const translations: RecoveryTranslation = {
  contactSupport: 'refx-servicing-recovery.contactSupport',
  contactSupportButton: 'refx-servicing-recovery.contactSupportButton',
  contactSupportUrl: 'refx-servicing-recovery.contactSupportUrl',
  retrieveBookingButtonLabel: 'refx-servicing-recovery.retrieveBookingButtonLabel',
  defaultError: 'refx-servicing-recovery.defaultError',
  retrieveBookingButtonUrl: 'refx-servicing-recovery.retrieveBookingButtonUrl',
  customRefundTeaserTitle: 'refx-servicing-recovery.customRefundTeaserTitle',
  customRefundTeaserBody: 'refx-servicing-recovery.customRefundTeaserBody',
  customRefundTeaserButtonLabel: 'refx-servicing-recovery.customRefundTeaserButtonLabel',
  pnrAlreadyCancelledInfoTitle: 'refx-servicing-recovery.pnrAlreadyCancelledInfoTitle',
  pnrAlreadyCancelledInfoMessage: 'refx-servicing-recovery.pnrAlreadyCancelledInfoMessage',
  nextTravel: 'refx-servicing-recovery.nextTravel',
  nextFlight: 'refx-servicing-recovery.nextFlight',
  nextFlightUrl: 'refx-servicing-recovery.nextFlightUrl',
  searchNextFlight: 'refx-servicing-recovery.searchNextFlight',
  rebookingInProgressTitle: 'refx-servicing-recovery.rebookingInProgressTitle',
  rebookingInProgressMessage: 'refx-servicing-recovery.rebookingInProgressMessage'
};
